import * as React from 'react';
import { withIntl, IntlProps } from 'ha/i18n';
import { ShowAlert, AlertType } from 'ha/modules/Alertbar/types';
import HttpStatus from 'ha/constants/HttpStatus';

interface Props extends IntlProps {
  location: {
    query: {
      state: string;
      code: string;
    };
  };
  onSendAlert: (alert: ShowAlert) => void;
  onChangeLocation: (url: string) => void;
  requestFacebookLogin: (code: string) => Promise<number>;
}

const kind = AlertType.Danger;
const persistent = true;
const dismissAfter = 5000;

class FacebookLogin extends React.PureComponent<Props> {
  componentDidMount() {
    const {
      onSendAlert,
      onChangeLocation,
      requestFacebookLogin,
      location: {
        query: { code, state },
      },
      intl: { T, urlResolver },
    } = this.props;

    requestFacebookLogin(code).then((statusCode: number) => {
      if (
        statusCode === HttpStatus.BAD_REQUEST ||
        statusCode === HttpStatus.NOT_FOUND
      ) {
        const text =
          {
            [HttpStatus.BAD_REQUEST]: T(
              'We could not connect to your Facebook account',
            ),
            [HttpStatus.NOT_FOUND]: T(
              'Data was not found and we could not connect to your Facebook account',
            ),
          }[statusCode] || T('Something went wrong');

        onSendAlert({ text, kind, persistent, dismissAfter });
      }

      if (state) {
        const redirectUrl = urlResolver.getRedirectUrl(state);
        onChangeLocation(redirectUrl);
        return;
      }

      onChangeLocation(urlResolver.getBaseUrl());
      return;
    });
  }

  render() {
    return null;
  }
}

export default withIntl(FacebookLogin);
